import { useMemo } from "react"
import { MeasureUnit } from "../../enums/animationSettings"

export default function useMeasureUnitSelection() {
    return useMemo(
        () => [
            {
                label: "mm",
                value: MeasureUnit.MM,
            },
            {
                label: "cm",
                value: MeasureUnit.CM,
            },
            {
                label: "in",
                value: MeasureUnit.IN,
            },
        ],
        [],
    )
}
